export default "__VITE_ASSET__Dl24mOrB__"